import convertCentsToDecimalNumber from '@/helper/convertCentsToDecimalNumber';

export function centsToDecimal(cents: number, withFractionDigits: boolean): string {
    return convertCentsToDecimalNumber(cents, withFractionDigits ? 2 : 0);
}
